import { mergeProps } from "@base-ui/react/merge-props"
import { useRender } from "@base-ui/react/use-render"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

// Tuned to the app's .chip: 26px tall pill, 3/9px padding, 12px text, with a
// "compact" size for the dense QA table rows.
const badgeVariants = cva(
  "inline-flex min-h-6.5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border px-2.25 py-0.75 text-xs whitespace-nowrap [&>svg]:pointer-events-none [&>svg]:size-3",
  {
    variants: {
      variant: {
        default: "border-border bg-surface-input text-muted-foreground",
        accent: "border-accent-line bg-accent text-accent-foreground",
      },
      size: {
        default: "",
        compact: "min-h-5.5 px-1.75 py-0.5 text-[11px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Badge({
  className,
  variant = "default",
  size = "default",
  render,
  ...props
}: useRender.ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return useRender({
    defaultTagName: "span",
    props: mergeProps<"span">(
      {
        className: cn(badgeVariants({ variant, size }), className),
      },
      props
    ),
    render,
    state: {
      slot: "badge",
      variant,
    },
  })
}

export { Badge, badgeVariants }
